import { useEffect, useState } from 'react';
import { MediaHelpers } from '@wajeez-web/core/api';
import { BiLoader } from 'react-icons/bi';
const GetTablecolumnImage = ({
  iconId,
  id,
}: {
  iconId: string;
  id: string;
}) => {
  return iconId ? (
    <img
      key={id}
      src={MediaHelpers.getPublicMediaById(iconId)}
      alt="icon"
      className="h-14 w-14 m-auto text-center shadow-sm border"
    />
  ) : (
    <BiLoader className="h-5 w-5 m-auto text-center animate-spin" />
  );
};

export default GetTablecolumnImage;
